import React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import NotFound from "./components/ErrorPage/NotFound";
import Unauthorized from "./components/ErrorPage/Unauthorized";

function getPropsFromJSON(context) {
  const scriptTag = document.getElementById(`${context}-props`);
  if (!scriptTag) return null;

  try {
    return JSON.parse(scriptTag.textContent);
  } catch (e) {
    throw new Error("Failed to parse app props:", e);
  }
}

function AppPropsOutlet({ appProps }) {
  return <Outlet context={{ appProps }} />;
}

export default function bootstrap({ routes }) {
  document.addEventListener("DOMContentLoaded", () => {
    const pageNode = document.getElementById("page");
    if (!pageNode) return;

    // Error/fallback paths (e.g. an unknown /v2/* URL) have no school context,
    // so the layout emits no app-props. The error pages don't need them, so
    // default to an empty object and still mount the router.
    const appProps = getPropsFromJSON("app") ?? {};

    const router = createBrowserRouter([
      {
        path: "/",
        element: <AppPropsOutlet appProps={appProps} />,
        // Error pages are shared across every entrypoint. The catch-all "*"
        // matches last, so it only fires for a path none of the feature routes
        // claim. /v2/401 is an explicit, directly-linkable permission page.
        children: [
          ...routes,
          { path: "/v2/401", element: <Unauthorized /> },
          { path: "*", element: <NotFound /> },
        ],
      },
    ]);

    createRoot(pageNode).render(<RouterProvider router={router} />);
  });
}
